// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-p_fP","galleryThumbnail_active":"c-p_fQ","galleryThumbnail__image":"c-p_fR"};